// src/components/modal/login/LoginWindow.jsx
import React, {useEffect, useState} from 'react';
import {AlertCircle, Lock, LogIn, User, X} from 'lucide-react';
import axios from 'axios';
import {DOMEN_BASE} from '../../../assets/config/constants';
import Cookies from 'js-cookie';

export default function LoginWindow({isOpen, onClose, onSuccess}) {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const PUBLIC_URL = '/wp-content/include-me/hotel_man_web/';


    useEffect(() => {
        if (isOpen) {
            setLogin('');
            setPassword('');
            setError('');
        }
    }, [isOpen]);

    const handleLogin = async () => {
        if (!login || !password) {
            setError('Заполните логин и пароль');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const res = await axios.get(`${DOMEN_BASE}/data/check_login.php`, {
                params: {login, password},
            });

            if (res.data?.records?.[0]?.result) {
                const user = res.data.records[0];

                Cookies.set('manager', user.name_login, {expires: 30});
                Cookies.set('manager_id', user.manager_id, {expires: 30});

                // confetti({
                //     particleCount: 120,
                //     spread: 80,
                //     origin: {y: 0.6},
                //     colors: ['#3B82F6', '#8B5CF6', '#EC4899', '#10B981'],
                // });

                const soundPath = PUBLIC_URL + 'static/media/checkout.dc5c87c7c12c12efccd2.mp3';
                const audio = new Audio(soundPath);
                audio.volume = 0.7;
                audio.play().catch(() => {
                });

                onSuccess(user);
                onClose();
            } else {
                setError('Неверный логин или пароль');
            }
        } catch (err) {
            setError('Ошибка сервера. Попробуйте позже.');
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') handleLogin();
    };

    if (!isOpen) return null;

    return (
        <>
            {/* Затемнение */}
            <div
                className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
                onClick={onClose}
            />

            {/* Окно — ПО ЦЕНТРУ, с отступами от BottomNav и Header */}
            <div className="fixed inset-x-4 top-1/2 -translate-y-1/2 z-50 max-w-md mx-auto">
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
                    {/* Заголовок */}
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8 text-center relative">
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-xl transition"
                        >
                            <X size={28}/>
                        </button>
                        <div
                            className="w-20 h-20 bg-white/20 rounded-full mx-auto mb-4 flex items-center justify-center">
                            <Lock size={42}/>
                        </div>
                        <h2 className="text-2xl font-bold">Вход в систему</h2>
                        <p className="text-blue-100 mt-2 text-lg">HOTEL MANAGER</p>
                    </div>

                    {/* Форма */}
                    <div className="p-8 space-y-6">
                        <div>
                            <label className="flex items-center gap-3 text-sm font-medium text-gray-700 mb-2">
                                <User size={20}/>
                                Логин
                            </label>
                            <input
                                type="text"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="admin"

                                className="w-full px-5 py-2 rounded-2xl border-2 border-gray-300 focus:border-blue-500 focus:outline-none transition text-lg"
                                autoFocus
                            />
                        </div>

                        <div>
                            <label className="flex items-center gap-3 text-sm font-medium text-gray-700 mb-2">
                                <Lock size={20}/>
                                Пароль
                            </label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="••••••••"
                                className="w-full px-5 py-2 rounded-2xl border-2 border-gray-300 focus:border-blue-500 focus:outline-none transition text-lg"
                            />
                        </div>

                        {/* Ошибка */}
                        {error && (
                            <div
                                className="bg-red-50 border border-red-200 text-red-600 px-5 py-4 rounded-2xl flex items-center gap-3">
                                <AlertCircle size={22}/>
                                <span className="font-medium">{error}</span>
                            </div>
                        )}

                        {/* Кнопка */}
                        <button
                            onClick={handleLogin}
                            disabled={loading}
                            className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-2xl font-bold text-lg hover:from-blue-700 hover:to-indigo-700 transition shadow-lg disabled:opacity-70 flex items-center justify-center gap-3"
                        >
                            {loading ? (
                                <div
                                    className="w-6 h-6 border-4 border-white/30 border-t-transparent rounded-full animate-spin"/>
                            ) : (
                                <LogIn size={24}/>
                            )}
                            {loading ? 'Проверка...' : 'Войти в систему'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
